import React, { useEffect, useState } from "react";

import { FormControl, FormHelperText, FormLabel, Checkbox, Box, List, ListItem } from "@mui/joy";
import { useTranslation} from 'react-i18next';

const InputCheckbox = (props) => {
    const {t} = useTranslation();
    
    const {
        editing,
        required,
        name,
        label,
        autoFocus,
        type = "checkbox",
        hint,
        haserror,
        options = [],
        className = "",
        mirrorField,
        value,
        onChange,
        error,
    } = props;
    let { disabled, readonly } = props;
    if (!editing) readonly = true;
    if (readonly) disabled = true;

   

    const [selectedItems, setSelectedItems] = useState([]);

    const handleSelect = (value) => {

        const isPresent = selectedItems.indexOf(value);
        if (isPresent !== -1) {
            const remaining = selectedItems.filter((item) => item !== value);
            setSelectedItems(remaining);
            return remaining;
        } else {
            setSelectedItems((selectedItems) => [...selectedItems, value]);
            return [...selectedItems, value];
        }
    };

    useEffect(() => {
        if (Array.isArray(value)) {
            setSelectedItems(value);
        } else {
            setSelectedItems([]);
        }
    }, [value]);

    const generateOptions = () => {
        return options.map((option, k) => (
            <ListItem key={k}>
                <Checkbox
                    key={k}
                    value={option.value}
                    label={option.label}
                    checked={selectedItems.includes(option.value)}
                    onChange={() => {
                        onChange(handleSelect(option.value));
                    }}

                    id={name}
                    type={type}
                    name={name}
                    variant="outlined"
                    autoComplete="off"

                    autoFocus={autoFocus}
                    disabled={disabled}
                    readOnly={readonly}
                    required={required}
                />
            </ListItem>
        ));
    };

    const invalid = Boolean(error);
    let generalClass = "form-element-control";
    generalClass += (editing) ? " editing" : " reading";
    generalClass += (invalid) ? " error" : "";
    generalClass += (required) ? " required" : "";
    generalClass += (disabled) ? " disabled" : "";
    generalClass += (readonly) ? " readonly" : "";

    return (
        <div className={("form-element checkbox " + className).trim()}>
            <Box className={(error) ? generalClass + " form-element-error" : generalClass}>
                {label ? <FormLabel className="form-element-label" htmlFor={name}>{t(label)} {mirrorField}</FormLabel> : null}
                <Box>
                    <List error={invalid} className={(error) ? generalClass + " form-element-error" : generalClass} role="group">
                        {generateOptions()}
                        <FormHelperText className="form-element-hint">
                            {(haserror || error) ? (
                                <>
                                    {error ? error.message : 'Messaggio di errore'}
                                </>
                            ) : (
                                <>
                                    {hint}
                                </>
                            )}
                        </FormHelperText>
                    </List>
                </Box>
            </Box>
        </div>
    );
};


export default InputCheckbox;
